import Vue from 'vue';
import Vuex from 'vuex';
import VueRouter from 'vue-router';
import store from './store';
import vuetify from './plugins/vuetify'
import router from './router'
import App from './App.vue';
import './assets/scss/theme.scss'
import Lang from 'vuejs-localization';
import {getLogout} from "./services/login";
import axios from 'axios';

Vue.use(VueRouter);

Vue.use(Vuex);

// Vue localization
Lang.requireAll(require.context('./lang', true, /\.js$/));
Vue.use(Lang);

// FILTERS
import './filters/capitalize'
import './filters/lowercase'
import './filters/uppercase'
import './filters/trim'
import './filters/formatDate'
import './filters/formatDateHour'
import './filters/formatDateTime'
import './filters/formatDateTimePrecise'
import './filters/formatIsoStart'
import './filters/formatIsoEnd'
import './filters/formatIsoEndFullTime'
import './filters/convertTime'

// Set this to false to prevent the production tip on Vue startup.
Vue.config.productionTip = false

const notProtectedRoute = () => {
    return !['ForgotPassword', 'Login', 'ResetPassword'].includes(router.currentRoute.name)
}

const logoutFunct = () => {
    localStorage.removeItem('userData')
    getLogout()
        .then(() => {
            if (notProtectedRoute()) router.push({
                name: 'Login',
                params: {lang: localStorage.selectedLanguage || 'en'}
            })
        })
        .catch((err) => {
            console.log(err)
            if (notProtectedRoute()) router.push({
                name: 'Login',
                params: {lang: localStorage.selectedLanguage || 'en'}
            })
        })
}

axios.interceptors.request.use((config) => {

    if (localStorage.selectedLanguage === undefined) {
        localStorage.selectedLanguage = 'en';
    }

    config.headers.common['X-localization'] = localStorage.selectedLanguage;

    return config;
});

axios.interceptors.response.use(
    (response) => {
        if (response?.status === 401) logoutFunct()

        if (response?.status === 403) {
            if (notProtectedRoute()) router.push({
                name: 'Home',
                params: {lang: localStorage.selectedLanguage || 'en'}
            })
        }

        return response
    },
    (error) => {
        console.log(error?.response)
        if (error?.response?.status === 401) logoutFunct()

        if (error?.response?.status === 403) {
            if (notProtectedRoute()) router.push({
                name: 'Home',
                params: {lang: localStorage.selectedLanguage || 'en'}
            })
        }

        return error
    })

export const bus = new Vue()

export default new Vue({
    vuetify,
    router,
    store: store(),
    render: (h) => h(App)
}).$mount('#app')
